import React from "react";

// Builds an area + line path from the graph_data values (already time-filtered
// by the backend). W/H are the SVG viewBox dimensions.
function buildPaths(values, W, H) {
  if (!values || values.length === 0) return null;
  const max = Math.max(...values, 1);
  const n = values.length;
  const stepX = n > 1 ? W / (n - 1) : W;
  const pts = values.map((v, i) => {
    const x = n > 1 ? i * stepX : W;
    const y = H - (v / max) * (H - 20) - 8;
    return [x, y];
  });
  const line = pts.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = `${line} L${W},${H} L0,${H} Z`;
  return { line, area, last: pts[pts.length - 1] };
}

function AudienceGrowth({ core = {}, breakdown, loading }) {
  const graph = core.graph_data || {};
  const labels = Object.keys(graph);
  const values = Object.values(graph).map((v) => Number(v) || 0);

  const total = core.total_users_count ?? 0;
  const pct = core.total_users_count_percentage;
  const hasPct = pct !== undefined && pct !== null && pct !== 0;
  const prev = hasPct ? Math.max(0, Math.round(total / (1 + pct / 100))) : null;

  const W = 620;
  const H = 180;
  const paths = buildPaths(values, W, H);
  const b = breakdown || {};

  // up to 5 evenly-spaced axis labels drawn from the graph keys
  const axis = (() => {
    if (labels.length === 0) return [];
    const idxs = [0, 0.25, 0.5, 0.75, 1].map((f) => Math.round(f * (labels.length - 1)));
    return [...new Set(idxs)].map((i) => labels[i]);
  })();

  return (
    <div className="dv-card">
      <div className="dv-head">
        <div>
          <h3>Audience growth</h3>
          <div className="dv-sub">New and activated learners over the selected period</div>
        </div>
      </div>

      <div className="gw-flex">
        <div className="gw-stats">
          <div className="growthnum">
            {total}
            {hasPct && (
              <span className={pct >= 0 ? "up" : "down"}> {pct >= 0 ? "▲" : "▼"} {Math.abs(pct)}%</span>
            )}
          </div>
          <div className="gw-sub">
            {prev !== null ? `${prev} → ${total} learners this period` : `${total} learners`}
          </div>
          <div className="gw-break">
            <div className="r"><span className="k" style={{ background: "#0FA3B8" }} /> Invited <b>{b.invited ?? 0}</b></div>
            <div className="r"><span className="k" style={{ background: "#7FCAD6" }} /> Self-serve <b>{b.self_serve ?? 0}</b></div>
            <div className="r"><span className="k" style={{ background: "#3F8F55" }} /> Activated <b>{b.activated_pct ?? 0}%</b></div>
          </div>
        </div>
        <div className="gw-chart">
          {paths ? (
            <>
              <svg className="spark-lg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
                <defs>
                  <linearGradient id="dvg" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0" stopColor="#0FA3B8" stopOpacity="0.26" />
                    <stop offset="1" stopColor="#0FA3B8" stopOpacity="0" />
                  </linearGradient>
                </defs>
                <line x1="0" y1="45" x2={W} y2="45" stroke="#EEF2F2" />
                <line x1="0" y1="90" x2={W} y2="90" stroke="#EEF2F2" />
                <line x1="0" y1="135" x2={W} y2="135" stroke="#EEF2F2" />
                <path d={paths.area} fill="url(#dvg)" />
                <path d={paths.line} fill="none" stroke="#0FA3B8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx={paths.last[0]} cy={paths.last[1]} r="4" fill="#0FA3B8" />
              </svg>
              {axis.length > 0 && (
                <div className="gw-axis">
                  {/* eslint-disable-next-line react/no-array-index-key */}
                  {axis.map((l, i) => <span key={i}>{l}</span>)}
                </div>
              )}
            </>
          ) : (
            <div className="dv-empty">{loading ? "Loading…" : "No activity in this period yet."}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AudienceGrowth;
